import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { getContrastingTextColor } from '../utils/colors';

export const LegendDot = ({
  dotNumber,
  color,
  maxHeight,
}: {
  dotNumber: string;
  color: string;
  maxHeight: number;
}) => {
  const size = Math.min(40, maxHeight * 0.8);
  const textColor = getContrastingTextColor(color);
  const textSize = size * 0.5;
  return (
    <Box
      width={size}
      height={size}
      alignItems="center"
      justifyContent="center"
      borderRadius="full"
      bg={color}
      mr="space4"
      style={{
        boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.12)',
      }}
    >
      <Text fontSize={`${textSize}px`} color={textColor}>
        {dotNumber}
      </Text>
    </Box>
  );
};
